import { call, put, takeEvery } from 'redux-saga/effects';
import { editGroupMetaData } from '../../requests/edit_group_meta_data_request';
import { getGroupsList } from '../../../User_group/requests/get_groups_list_request';
import { editGroupMetaDataRequestFailure } from '../actions/edit_group_meta_data.actions';
import { EDIT_GROUP_METADATA_REQUEST } from '../constants/edit_group_data.constants';
import { message_error, message_success } from '../../../../../components/Message';
import { getGroupsListSuccess } from '../../../User_group/redux/actions/get_groups_list.actions';

function* editGroupMetaDataSagaRequest({ _id, params }) {
    const groupMetaData = yield call(editGroupMetaData, _id, params);
    if (groupMetaData.result) {
        const { result, options } = yield call(getGroupsList, _id);
        if (result) {
            yield put(getGroupsListSuccess(options));
            message_success('Data changed successfully!');
        }
    } else {
        yield put(editGroupMetaDataRequestFailure(groupMetaData.error));
        message_error(groupMetaData.error);
    }
}

export default function* editGroupMetaDataSaga() {
    yield takeEvery(EDIT_GROUP_METADATA_REQUEST, editGroupMetaDataSagaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/sagas/edit_group_meta_data.saga.js